import { render, staticRenderFns } from "./UpgradeToKYC.vue?vue&type=template&id=ce298752&scoped=true&"
import script from "./UpgradeToKYC.vue?vue&type=script&lang=js&"
export * from "./UpgradeToKYC.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeToKYC.vue?vue&type=style&index=0&id=ce298752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce298752",
  null
  
)

export default component.exports